import React from "react";

export default function ReportCard({ title, embedUrl, fullscreen = false }) {
  return (
    <div className={`w-full h-full ${fullscreen ? "p-0 m-0" : "p-4"}`}>
      <iframe
        src={embedUrl}
        title={title}
        className="w-full h-full border-0"
        allowFullScreen
      ></iframe>
    </div>
  );
}
